// extracted by css-extract-rspack-plugin
export default {"downloadBtn":"TA5mL8ip_AMRPpUi"};